export const STAGE_COLORS = {
  INDIGO: { light: '#eef2ff', base: '#6366f1', dark: '#4338ca' },
  ORANGE: { light: '#fff7ed', base: '#F97316', dark: '#c2410c' },
  PURPLE: { light: '#f3e8ff', base: '#a855f7', dark: '#7e22ce' },
};
export const getStageColor = stageIndex => [STAGE_COLORS.INDIGO, STAGE_COLORS.ORANGE, STAGE_COLORS.PURPLE][Math.min(Math.max(stageIndex, 0), 2)];
export const prefersReducedMotion = () => typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
export const getMotionClasses = (type = 'stage-shift') => prefersReducedMotion() ? (type === 'stage-shift' ? 'transition-colors duration-350' : 'opacity-100') : (type === 'stage-shift' ? 'animate-stageShift' : 'animate-subtlePulse');
